import { useCallback, useEffect, useState } from 'react'
import { ApiEndpoints } from '../../helper/ApiEndpoints';
import ApiRequest from '../../helper/ApiRequest';
import DataTable from '../datatable/DataTable';
import { Link } from 'react-router-dom';
import '../author/author.css';

const seoListEndpoint = ApiEndpoints.seo.seoList;
const seoDeleteEndpoint = ApiEndpoints.seo.seoDelete;
const seoEditPath = "edit-seo";
const tableHeader = ["Title", "Url", "Description"];
const tbody = ["title", "url", "description"];

export default function SeoListing() {
  const [data, setData] = useState([]);
  
  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest("GET", seoListEndpoint);
        const result = response.seos;
        setData(result);
  
      } catch (error) {
        console.log(error);
      }
    },[seoListEndpoint]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleDelete = useCallback(
    async (seo_id) => {
      const payload = { seo_id };
      try {
        await ApiRequest("POST", seoDeleteEndpoint, payload);
        dataFetch();
      } catch (error) {
        console.log(error);
      }
    },[]);

  return (
    <>
      <div className="header-add-category">
        <h5>SEO</h5>
      </div>
      <div className="add-author-section">
        <Link className="default-btn" to="/admin/add-seo">
          add Seo
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={seoEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
